import { render, staticRenderFns } from "./AsignarEstacionRecepcionModal.vue?vue&type=template&id=4886a1f1&"
import script from "./AsignarEstacionRecepcionModal.vue?vue&type=script&lang=js&"
export * from "./AsignarEstacionRecepcionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports